import React from "react";
import { Form, Checkbox } from "antd";

export default function CheckboxInput({
  getFieldDecorator,
  callback = () => {},
  label,
  name,
  size = "default",
  setFieldsValue,
  initialValue = false,
}) {
  const handleChange = (e) => {
    setFieldsValue({
      [name]: e.target.checked,
    });
    callback(name, e.target.checked);
  };

  return (
    <Form.Item>
      {getFieldDecorator(name, {
        valuePropName: "checked",
        initialValue: initialValue,
      })(<Checkbox onChange={handleChange}>{label}</Checkbox>)}
    </Form.Item>
  );
}
